import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import ScheduleDurationList from "./ScheduleDurationList.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScheduleListComponentVariableBuiltValue',
    props: {
        value: {}
    },
    setup(__props) {
        const props = __props;
        const isDelayList = (value) => {
            return (Array.isArray(value) && value.every((item) => typeof item === "string"));
        };
        const valueProxy = computed(() => {
            return isDelayList(props.value) ? props.value : [];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ScheduleDurationList, {
                scheduleList: valueProxy.value,
                "onUpdate:scheduleList": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event)),
                placeholder: '+ New Value'
            }, null, 8 /* PROPS */, ["scheduleList"]));
        };
    }
});
